<ng-container *ngIf="{
  request: requestEnergyData$ | async,
  status : requestIsPending$ | async,
  data: chartOpts$ | async,
} as resolver">
  <ng-container *ngIf="resolver.data as data; else noDataSkeleton">
    <app-button-toggle-select
      *ngIf="selectedMode$ | async as mode"
      id="button-toggle"
      [ngClass]="{ 'visibility: hidden' : todayMode }"
      [value]="mode"
      [options]="[{
        value: 'month',
        label: labels.month,
      }, {
        value: 'year',
        label: labels.year,
      }]"
      (valueChange)="changeSelectMode($event)">
    </app-button-toggle-select>
    <calendar-picker
      *ngIf="selectedMode$ | async as mode"
      id="calendar-picker"
      class="w-full"
      [ngClass]="{ 'visibility: hidden' : todayMode }"
      [startView]="mode === 'month' ? 'year' : 'multi-year'"
      [disabled]="resolver.status || false"
      [mode]="mode"
      (dateSelected)="dateSelection$.next($event)">
      <button
        *ngIf="data.hasValues && system?.source === 'aws'"
        class="custom-mat-button-primary ml-0 custom-mat-button-border"
        mat-button
        (click)="onExport(data.graph.series)">
        <mat-icon class="m-0">download</mat-icon>
      </button>
    </calendar-picker>
    <lib-block-title
      id="energy-overview-title"
      [title]="labels.title">
    </lib-block-title>
    <app-custom-source-selector
      *ngIf="sourceOptions$ | async as sourceOptions"
      id="source-selector"
      [source]="sourceSelection$.value"
      [options]="sourceOptions"
      (selection)="updateSourcesSelection($event)">
    </app-custom-source-selector>
    <ng-container *ngIf="data.hasValues; else noData">
      <div
        id="energy-overview"
        class="block-bg-contrast min-h-100"
        echarts
        [options]="data.graph"
        (chartInit)="onChartInit($event)">
      </div>

      <div
        id="energy-overview-reduced"
        class="fx-gap-3 min-h-100">
        <div
          *ngFor="let graph of data.reducedGraph"
          class="block-bg-contrast"
          echarts
          [options]="graph"
          (chartInit)="onChartInit($event)">
        </div>
      </div>
    </ng-container>

    <ng-template #noData>
      <div
        id="energy-overview"
        class="block-bg-contrast fx-col fx-center fx-gap-3">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>

      <div
        id="energy-overview-reduced"
        class="block-bg-contrast fx-col fx-center fx-gap-3 h-85">
        <mat-icon
          class="s-20"
          svgIcon="no_data">
        </mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-template>

    <lib-energy-statistics-card
      *ngIf="energyStatistics$ | async as energyStatistics"
      id="energy-statistics"
      [labels]="{
        avg: labels.statisticsAvg,
        max: labels.statisticsMax,
        min: labels.statisticsMin,
        total: labels.statisticsTotal,
        batteryTitle: labels.statisticsBatteryTitle,
        consumedTitle: labels.statisticsConsumedTitle,
        generatedTitle: labels.statisticsGeneratedTitle,
        gridTitle: labels.statisticsGridTitle,
        chargeSubtitle: labels.statisticsChargeSubtitle,
        dischargeSubtitle: labels.statisticsDischargeSubtitle,
        exportSubtitle: labels.statisticsExportSubtitle,
        importSubtitle: labels.statisticsImportSubtitle,
        irradiationTitle: labels.statisticsIrradiationTitle,
      }"
      [locate]="locate"
      [data]="energyStatistics">
    </lib-energy-statistics-card>
  </ng-container>
</ng-container>

<ng-template #noDataSkeleton>
  <ion-skeleton-text
    id="energy-overview-title"
    class="w-42 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="calendar-picker"
    class="w-90 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="source-selector"
    class="w-full h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="energy-overview"
    class="w-full h-100"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>
